import { HtsClassificationTopic, HtsTopicKind } from "../constants";
import { HtsClassificationTopicConfig } from "../schemas";

export const specialSkills: HtsClassificationTopicConfig = {
  id: HtsClassificationTopic.SPECIAL_SKILLS,
  label: "Special skills",
  kind: HtsTopicKind.Readiness,
  narrativeFields: [
    "the achievement or skill itself (language, sport, art, academics, life-saving action, licence)",
    "how far it was taken (participation vs. sustained pursuit vs. formal recognition)",
    "whether it's specific, dated, and verifiable rather than a vague claim",
  ],
  followUpTriggers: [
    // The rubric's own instruction: probe for the specifics that make a
    // claim scoreable, never for more achievements.
    "the claim is vague (\"I'm pretty athletic\", \"I know some French\") with no specifics",
    "no indication of when/where/at what level the achievement happened",
  ],
  hardBarrierFacts: [],
};
